import Swiper from "swiper";
import { initIntersectionObserver } from "@plugins";

const aboutShopSlider = document.querySelector(".js-about-shop-slider-init");

if (aboutShopSlider) {
    initIntersectionObserver(aboutShopSlider, aboutShopSwiperInit);
}

function aboutShopSwiperInit(aboutShopSlider) {
    const swiperContainer = aboutShopSlider.querySelector(".js-about-shop-swiper-container");
    const swiperThumbsContainer = aboutShopSlider.querySelector(".js-about-shop-swiper-thumbs");

    if (swiperContainer && swiperThumbsContainer) {
        const aboutShopSwiperThumbs = new Swiper(swiperThumbsContainer, {
            spaceBetween: 8,
            slidesPerView: 6,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
            observer: true,
            watchOverflow: true,
        });

        new Swiper(swiperContainer, {
            navigation: {
                nextEl: ".js-about-shop-thumb-next",
                prevEl: ".js-about-shop-thumb-prev",
            },
            pagination: {
                el: ".js-about-shop-swiper-pagination",
                clickable: true,
            },
            thumbs: {
                swiper: window.mobileMedia ? null : aboutShopSwiperThumbs,
                slideThumbActiveClass: "active",
            },
        });
    }
}
